import React from "react";
import { Box } from "theme-ui";
import { ActionBanner } from "../../molecules";
import { navigate } from "@reach/router";

const ActionBannerSectionHome = ({
    image,
    imageAlt,
    title,
    desc,
    primaryBtnLabel,
    primaryBtnId,
    primaryBtnLink,
    secondaryBtnLabel,
    secondaryBtnId,
    secondaryBtnLink,
}) => {
    return (
        <Box>
            <ActionBanner
                variant="BodyBannerV8"
                theme="primary"
                image={image}
                imageAlt={imageAlt}
                title={title}
                desc={desc}
                primaryBtnLabel={primaryBtnLabel}
                primaryBtnId={primaryBtnId}
                onPrimaryButtonClick={() => navigate(primaryBtnLink)}
                secondaryBtnLabel={secondaryBtnLabel}
                secondaryBtnId={secondaryBtnId}
                onSecondaryButtonClick={() => navigate(secondaryBtnLink)}
                testimonial="true"
                customStyles={{ mb: 0 }}
            />
        </Box>
    );
};

export default ActionBannerSectionHome;
